// $(document).on('DOMContentLoaded', function() {
//   $('[data-src]').each(function(index, el) {
//     this.src = this.dataset.src
//   })
// })

var myLazyLoad = new LazyLoad({
  data_src: 'src',
  data_srcset: 'srcset',
  show_while_loading: true, // best for progressive JPEG
  callback_set: function (img) {
    picturefill({
      elements: [img]
    })
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/_lazy-load.js